"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _wrapRegExp = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapRegExp");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var version_1 = require("./version");

var Versioning = /*#__PURE__*/function () {
  function Versioning() {
    _classCallCheck(this, Versioning);
  }

  _createClass(Versioning, null, [{
    key: "urlWithVersion",

    /**
     * Return URL with versioning information appended
     */
    value: function urlWithVersion(url) {
      var urlWithVersion = new URL(url);
      urlWithVersion.searchParams.append(Versioning.X_AMZN_VERSION, Versioning.sdkVersion);
      urlWithVersion.searchParams.append(Versioning.X_AMZN_USER_AGENT, Versioning.sdkUserAgentLowResolution);
      return urlWithVersion.toString();
    }
  }, {
    key: "sdkName",

    /**
     * Return string representation of SDK name
     */
    get: function get() {
      return 'amazon-chime-sdk-js';
    }
    /**
     * Return string representation of SDK version
     */

  }, {
    key: "sdkVersion",
    get: function get() {
      return version_1.default.semverString;
    }
    /**
     * Returns the parts of the semver, so major/minor/patch can be extracted individually.
     */

  }, {
    key: "sdkVersionSemVer",
    get: function get() {
      var _a, _b, _c;

      var v = version_1.default.semverString.match( /*#__PURE__*/_wrapRegExp(/^([0-9]+)\.([0-9]+)(?:\.([0-9]+))?/, {
        major: 1,
        minor: 2,
        patch: 3
      }));
      return {
        major: (_a = v === null || v === void 0 ? void 0 : v.groups) === null || _a === void 0 ? void 0 : _a.major,
        minor: (_b = v === null || v === void 0 ? void 0 : v.groups) === null || _b === void 0 ? void 0 : _b.minor,
        patch: (_c = v === null || v === void 0 ? void 0 : v.groups) === null || _c === void 0 ? void 0 : _c.patch
      };
    }
    /**
     * Return the SHA-1 of the Git commit from which this build was created.
     */

  }, {
    key: "buildSHA",
    get: function get() {
      // Skip the leading 'g'.
      return version_1.default.hash.substr(1);
    }
    /**
     * Return low-resolution string representation of SDK user agent (e.g. `chrome-78`)
     */

  }, {
    key: "sdkUserAgentLowResolution",
    get: function get() {
      var browserBehavior = new DefaultBrowserBehavior_1.default();
      return "".concat(browserBehavior.name(), "-").concat(browserBehavior.majorVersion());
    }
  }]);

  return Versioning;
}();

exports.default = Versioning;
Versioning.X_AMZN_VERSION = 'X-Amzn-Version';
Versioning.X_AMZN_USER_AGENT = 'X-Amzn-User-Agent';